export var SparkJobSortField;
(function (SparkJobSortField) {
    SparkJobSortField["SPARK_JOB_SORT_FIELD_CREATED_AT"] = "createdAt";
    SparkJobSortField["SPARK_JOB_SORT_FIELD_NAME"] = "name";
    SparkJobSortField["SPARK_JOB_SORT_FIELD_ATTEMPTS"] = "attempts";
})(SparkJobSortField || (SparkJobSortField = {}));
